import {
  LEDGER_REASONS,
  LEDGER_REF_TYPES,
  LEDGER_SOURCES,
  MODEL_USAGE_KIND_BY_REF_TYPE,
  paidActionOfReason,
} from '@drama/contracts/platform'

// 流水取值的显示名称，名单见 @drama/contracts 的 billing-ledger.js。名单外的值（本地测试数据）原样显示。

export function ledgerReasonLabel(t, reason) {
  const paid = paidActionOfReason(reason)
  if (paid !== null) {
    const name = t(`visualGameAdmin.billing.actionNames.${paid.action}`)
    return paid.refund ? t('visualGameAdmin.billing.actionRefund', { name }) : name
  }
  return LEDGER_REASONS.includes(reason) ? t(`visualGameAdmin.billing.ledgerReasons.${reason}`) : reason
}

export function ledgerSourceLabel(t, source) {
  return LEDGER_SOURCES.includes(source) ? t(`visualGameAdmin.billing.ledgerSources.${source}`) : source
}

export function ledgerRefTypeLabel(t, refType) {
  return LEDGER_REF_TYPES.includes(refType) ? t(`visualGameAdmin.billing.ledgerRefTypes.${refType}`) : refType
}

/** 消耗结构的一块：按调用计费的流水要带上模型类别，其他只看原因。 */
export function spendLabel(t, { reason, ref_type: refType }) {
  const label = ledgerReasonLabel(t, reason)
  if (reason !== 'model_usage') return label
  const kind = MODEL_USAGE_KIND_BY_REF_TYPE[refType]
  const kindLabel = kind === undefined ? ledgerRefTypeLabel(t, refType ?? '') : t(`visualGameAdmin.billing.modelUsageKinds.${kind}`)
  return `${label} · ${kindLabel}`
}
